// packages import
import { TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { FC } from "react";
import { Link } from "react-router-dom";
// component import
import { StickyTable } from "../common/StickyTable";
import { CaseTypeMenu } from "../menus/CaseType";
import { CaseTypeSkeleton } from "../skeletons/CaseTypeSkeleton";
// others
import { CASE_TYPE_TABLE_HEADERS } from "../../constants";
import { CaseTypeListingProps } from "../../interfaceTypes";
import { titleize } from "../../utils";

export const CaseTypeListing: FC<CaseTypeListingProps> = ({ caseTypes, loading, dispatch }): JSX.Element => (
  <StickyTable height={'208px'}>
    <TableHead>
      <TableRow>
        {CASE_TYPE_TABLE_HEADERS.map((item, index) => {
          const lastIndex = CASE_TYPE_TABLE_HEADERS.length - 1 === index

          return (
            <TableCell
              align={lastIndex ? "center" : "left"}
              component="th"
              key={index}
              sx={{ maxWidth: lastIndex ? '100px' : 'unset', minWidth: lastIndex ? '50px' : '150px' }}
            >
              {item}
            </TableCell>
          )
        })}
      </TableRow>
    </TableHead>

    {loading ?
      <CaseTypeSkeleton noOfRows={10} />
      :
      <TableBody>
        {caseTypes?.map(caseType => {
          const { name, id, totalCaseCount, lawTypeId } = caseType || {}
          const caseLength = (totalCaseCount || 0) > 0

          return (
            <TableRow key={id} hover>
              <TableCell>
                <Link to={`/law-type/${lawTypeId}/case-type/${id}`}>
                  <Tooltip title={titleize(name || '')} arrow placement='top-start'>
                    <Typography noWrap maxWidth='300px' color='primary'>
                      {name}
                    </Typography>
                  </Tooltip>
                </Link>
              </TableCell>

              <TableCell>
                <Typography noWrap maxWidth='300px' color='black' textTransform='capitalize'>
                  {caseLength ? `${totalCaseCount} active matters` : 'No active matters'}
                </Typography>
              </TableCell>

              <TableCell align='center'>
                <CaseTypeMenu caseType={caseType} dispatch={dispatch} />
              </TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    }
  </StickyTable>
)